<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <form @submit.prevent="createPublicChat">
          <v-flex xs12>
            <v-text-field
              name="title"
              label="Public chat title"
              id="title"
              v-model="title"
              type="text"
              required
            />
            <v-combobox
              v-model="status"
              :items="items"
              label="Select chat status"
            ></v-combobox>
            <v-combobox
              v-model="subscribers"
              label="Chat users"
              multiple
              chips
            ></v-combobox>
            <v-btn type="submit">
              Create
            </v-btn>
          </v-flex>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        title: '',
        status: '',
        subscribers: [],
        items: ['active', 'readonly', 'deleted']
      }
    },
    methods: {
      createPublicChat () {
        if (this.title !== '') {
          let key = 0
          const chatData = { 
            title: this.title, 
            status: this.status, 
            subscribers: this.subscribers.map(userId => Number(userId))
          }
          console.log('creating public chat', chatData)
          this.$store.dispatch('createPublicChat', chatData).then((value) => {
            console.log('public chat created', value)
            key = value
            this.$router.push('/chat/' + key)
          })
        }
      }
    }
  }
</script>
